module.exports = __webpack_public_path__ + "app-static/img/p_07.02e98029.jpg";